import React, { Component } from 'react';
import { Link } from "react-router-dom";
export class Chapter1 extends Component {
  static displayName = Chapter1.name;

  render () {
    return (
      <div>
        <section
      id="jeevan-parichay"
      className="container"
      style={{ marginTop: "60px", marginBottom: "80px" }}
    >
      <div className="card" style={{ padding: "34px 36px" }}>
        {/* Main Heading */}
        <h2
          style={{
            color: "var(--accent)",
            textAlign: "center",
            fontSize: "clamp(26px,3vw,38px)",
            marginBottom: "18px",
          }}
        >
          🌼 अध्याय–1 दिव्य अवतरण🌼
        </h2>

        {/* Intro portrait + short line */}
        <div
          style={{
            display: "flex",
            gap: "24px",
            alignItems: "center",
            flexWrap: "wrap",
            marginBottom: "18px",
          }}
        >
          <div style={{ flex: "0 0 220px", textAlign: "center" }}>
            <div
              style={{
                width: "200px",
                height: "200px",
                borderRadius: "50%",
                overflow: "hidden",
                margin: "0 auto",
                border: "4px solid var(--accent)",
                boxShadow: "0 20px 60px rgba(0,0,0,0.6)",
              }}
            >
              <img
                src="images/IMG_5427-removebg-preview.png"
                alt="Swami Brahmanand Saraswati Ji"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  display: "block",
                }}
              />
            </div>
            <div style={{ marginTop: "10px", color: "var(--muted)", fontSize: "13px" }}>
              पूज्य स्वामी ब्रह्मानंद सरस्वती जी
            </div>
          </div>

          <div style={{ flex: 1, minWidth: "260px" }}>
            <p style={{ margin: 0, color: "rgba(255,235,200,0.95)", lineHeight: 1.8 }}>
              <strong>दैवावतार का प्राकट्य: पोखवां की पावन मिट्टी में एक चमत्कारी जन्म</strong>
              <br />
              बिहार के मिथिला अंचल का एक साधारण-सा गाँव — पोखवां। चारों ओर हरियाली, मिट्टी में
              गंगाजल सी शुचिता, और गाँव के मध्य विराजती थीं — वागेश्वरी माई। स्थानीय जनश्रुति
              कहती है — “जिसे हर कहीं निराशा मिले, वह यहाँ आकर भींची मुट्ठियाँ खोल दे; माई उसकी
              झोली आशा से भर देती हैं।” इसी पुण्यभूमि पर एक ऐसी घटना घटने वाली थी, जिसने केवल एक
              परिवार का नहीं, भारतीय संत-परंपरा का भाग्य बदल देना था।
            </p>
          </div>
        </div>

        <hr
          style={{
            border: "none",
            height: "1px",
            background: "rgba(255,255,255,0.03)",
            margin: "18px 0 22px",
          }}
        />

        {/* Full narrative */}
        <div style={{ marginTop: "22px" }}>
          <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>🌼 एक शिक्षिता, श्रद्धालु माँ</h3>
          <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
            उन दिनों विवाह अक्सर कम आयु में ही हो जाया करता था। परन्तु गुरुदेव की पूज्य माता —
            जिनदेवी (जिन) — कहती थीं:
            <br />
            “ईश्वर की कृपा से मैं मैट्रिक उत्तीर्ण कर इंटरमीडिएट में पढ़ रही थी, तभी मेरा विवाह
            पोखवां के प्रतिष्ठित जमींदार श्री जगदीश नारायण बाबू से हुआ।”
            <br />
            विवाह के पाँच वर्ष बाद गौना हुआ। और इसके बाद भी तीन-चार वर्षों तक गोद सूनी रही।
            <br />
            पति-पत्नी शांत, भक्तिमय, संतोषी — पर माता-पिता और परिवार की चिंताएँ समय के साथ बढ़ने
            लगीं।
          </p>

          <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>🌿 संतान-विहीन वंश, व्याकुल हृदय</h3>
          <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
            गुरुदेव के मातामह — जिनके पाँच पुत्रों में से किसी को संतान न थी — अब अपनी प्रिय पुत्री
            के दाम्पत्य में भी संतान का प्रकाश न देखकर भीतर तक उदास रहने लगे।
            <br />
            अंततः उन्होंने चिंता व्यक्त करते हुए एक पत्र अपने समधी स्व. श्री केशव नारायण शर्मा जी
            को नाई के हाथ भेजा।
            <br />
            पत्र तो समय की धूल बन गया, पर वह क्षण आज भी अमिट है।
            <br />
            जैसे ही केशव बाबू ने वह पत्र पढ़ा, उन्होंने हाथ में जल लेकर दृढ़ संकल्प किया। अपने
            पुत्र जगदीश बाबू को सम्मुख खड़ा करते हुए नाई से बोले—
            <br />
            <strong>
              “जाओ, अपने मालिक से कह दो— जब भी संतान होगी, वागेश्वरी माई की कृपा से पहली संतान
              पुत्र ही होगा।”
            </strong>
            <br />
            उनके स्वर में विश्वास नहीं — श्रद्धा की अडिग पत्थर की लकीर थी।
          </p>

          <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>🌺 वागेश्वरी माई: चमत्कार की छाया</h3>
          <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
            पोखवां में विराजमान वागेश्वरी माई स्वयंभू रूप से प्रकट हुई देवी हैं। यहाँ लोग प्रयत्न
            लेकर नहीं, आस्था लेकर आते हैं — और लौटते हैं ईश्वर की अनुभूति लेकर।
            <br />
            जिनके द्वार पर माई की दृष्टि पड़ी, उनके जीवन में चमत्कार हुए। लेकिन अब एक ऐसा चमत्कार
            होने वाला था, जिसे आने वाली पीढ़ियाँ इतिहास के स्वर्णाक्षरों में दर्ज करेंगी।
          </p>

          <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>
            🔥 दैवी संकेत: महात्माओं का अनोखा आगमन
          </h3>
          <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
            संकल्प के केवल दो महीने बाद, गुरुदेव के परमहंस गुरु स्वामी अद्वैतानंद सरस्वती जी —
            जो उस समय वनखंडी में विराजमान थे — अचानक, बिना किसी सूचना के — पोखवां पहुँच गए।
            <br />
            सेवा-सत्कार हुआ। प्रस्थान से पूर्व वे केशव बाबू से बोले—
            <br />
            “मेरा एक शिष्य शीघ्र ही तुम्हारे द्वार पर आएगा, उसका विशेष ध्यान रखना।”
            <br />
            परन्तु यह कौन होगा? कहाँ से आएगा? कब आएगा? कोई नहीं जानता था।
            <br />
            कुछ ही दिनों बाद गुरुदेव की माता जी को गर्भ हुआ।
            <br />
            और तब प्रारम्भ हुई एक अद्भुत घटना—
            <br />
            प्रतिदिन 10–20 साधु, संन्यासी, महात्मा… कभी वैष्णव वेष में, कभी दिगम्बर साधु, कभी
            रुद्राक्ष-मुण्डमालाधारी योगी — बिना निमंत्रण, बिना परिचय, बिना कारण — घर की देहरी पर
            खड़े होते।
            <br />
            गाँव वाले कहते —
            <strong> “लगता है घर में कोई देव आत्मा आने वाली है।”</strong>
            <br />
            घर में जैसे अदृश्य घंटियों की ध्वनि गूँज रही थी।
          </p>

          <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>
            🌞 माघ शुक्ल पंचमी — सरस्वती पूजा का प्रभात
          </h3>
          <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
            सन् 1902। माघ शुक्ल पंचमी — ज्ञान की देवी का दिन।
            <br />
            भोर के 4 बजकर 30 मिनट। रेवती नक्षत्र की शांत छाया में एक अलौकिक चैतन्य पृथ्वी पर
            अवतरित हुआ।
            <br />
            एक नवजात शिशु… परन्तु मुख पर तेज ऐसा कि दाइयों ने हाथ जोड़ लिए। नेत्रों में गहरी, दैवी
            करुणा। और ललाट पर शांति की दिव्य आभा।
            <br />
            उस क्षण किसी ने भी उस बालक को सामान्य मनुष्य नहीं माना।
            <br />
            वह दिन पोखवां की मिट्टी में दिव्यता बनकर अंकित हो गया।
          </p>

          <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>
            🌟 भविष्यवाणी — धर्मराज या यति-राज
          </h3>
          <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
            कुछ महीनों बाद फिर स्वामी अद्वैतानंद सरस्वती जी आए।
            <br />
            उन्होंने बालक को गोद में लिया, लंबे समय तक मौन दृष्टि से निहारा, और बोल उठे—
            <br />
            <strong>
              “इस बालक के चरणों में चक्र है। यह एक स्थान पर स्थिर नहीं रहेगा। यह या तो धर्मराज
              होगा… या यति-राज.”
            </strong>
            <br />
            भविष्यवाणी थी — पर वास्तव में वह भविष्य का उद्घोष था।
            <br />
            युगों-युगों की तपस्या का फल, असंख्य जन्मों की साधना का परिणाम — यह बालक आगे चलकर
            भारतवर्ष के आध्यात्मिक इतिहास में स्वर्णिम अक्षरों से अंकित हुआ:
            <br />
            <strong>“गुरुदेव स्वामी ब्रह्मानंद सरस्वती जी महाराज”</strong>
            <br />
            — अद्वैत वेदांत के महामहिम, — परमहंसों के मुकुट, — और जगत-कल्याण के प्रतीक।
          </p>

          <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>✨ यह तो बस आरम्भ है…</h3>
          <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
            यह कहानी केवल एक जन्म की नहीं — यह दैवी योजना, ईश्वरीय संकेत, और मानवता के उत्थान की
            पहली कड़ी है।
            <br />
            अब आरम्भ होता है उस शिशु का अद्भुत जीवन, जो संसार में आया साधारण रूप में, पर जिसका
            लक्ष्य था — समस्त जगत को जागृत करना।
          </p>
        </div>

        {/* call to action */}
        <div style={{ textAlign: "center", marginTop: "26px" }}>
          <Link to="/Chapter2" className="btn" style={{ display: "inline-block" }}>अगला अध्याय</Link>
        </div>
      </div>
    </section>
      </div>
    );
  }
}